/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useStore } from '@stores';
import { Navigate } from 'react-router-dom';

const Logout = () => {
  const { authenticationStore } = useStore();

  authenticationStore!.logout();

  return <Navigate to="/login" replace />;
};

export default Logout;
